import { createContext, useContext } from "react";

export const AuthContext = createContext({
  user: undefined,
  isLoading: undefined,
  error: undefined,
  setUser: () => {},
  setIsLoading: () => {},
  setError: () => {},
  login: () => {},
  logout: () => {},
});

export const useAuthContext = () => useContext(AuthContext);
